module.exports = __webpack_public_path__ + "static/media/heroBack5.a02b9a94.svg";